var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup success"},[_c('div',{staticClass:"bg"}),_c('div',{staticClass:"container"},[_c('a',{staticClass:"btn-close",on:{"click":_vm.popupToggle}}),_vm._m(0),_c('div',{staticClass:"btn-box",on:{"click":_vm.popupToggle}},[_c('a',{staticClass:"btn-black"},[_vm._v("關閉")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("親愛的貴賓"),_c('br'),_vm._v("您的資料已成功送出。")])
}]

export { render, staticRenderFns }